var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ArrayMinSize, IsArray, IsEnum, IsUUID } from 'class-validator';
import { BookingDeclineReason } from '../enums/booking-decline-reason.enum.js';
/**
 * Body for `POST /appointments/decline-booking-batch` (PRD #1343, RS-004). The
 * practice declines a whole booking pass in one atomic action, with a single
 * fixed reason shown to the patient verbatim for every hold. Runs the
 * practice-origin cancel path (never fee-eligible) for each member.
 */
export class DeclineBookingBatchDto {
    appointmentIds;
    reason;
}
__decorate([
    IsArray(),
    ArrayMinSize(1),
    IsUUID('4', { each: true }),
    __metadata("design:type", Array)
], DeclineBookingBatchDto.prototype, "appointmentIds", void 0);
__decorate([
    IsEnum(BookingDeclineReason),
    __metadata("design:type", String)
], DeclineBookingBatchDto.prototype, "reason", void 0);
//# sourceMappingURL=decline-booking-batch.dto.js.map